import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../constants';
import { useAddressLabel } from '../../hooks/use-address-label';
import { AddressInput } from '../../ui/address-input';
import { TextField } from '../../ui/text-field';
const MlaStreetName = _ref => {
  let {
    autocomplete,
    ...rest
  } = _ref;
  const fieldType = FIELD_TYPES.MLA_STREET_NAME;
  const label = useAddressLabel('streetName');
  return autocomplete ? /*#__PURE__*/React.createElement(AddressInput, _extends({}, rest, {
    fieldType: fieldType,
    label: label
  })) : /*#__PURE__*/React.createElement(TextField, _extends({}, rest, {
    fieldType: fieldType,
    label: label
  }));
};
export default MlaStreetName;
//# sourceMappingURL=mla-street-name.js.map